import { _ as e } from "../_rollupPluginBabelHelpers-d2f9cf82.js";
import { useState as n, useEffect as r } from "react";
var t = function (t) {
  var o = n(!1),
    i = e(o, 2),
    d = i[0],
    u = i[1];
  function a(e) {
    e.key === t && u(!0);
  }
  var f = function (e) {
    e.key === t && u(!1);
  };
  return r(function () {
    return window.addEventListener("keydown", a), window.addEventListener("keyup", f), function () {
      window.removeEventListener("keydown", a), window.removeEventListener("keyup", f);
    };
  }, []), d;
};
export { t as default };